import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface FeatureToggles {
  marketplace: boolean;
  trade_ins: boolean;
  repairs: boolean;
  demo_mode: boolean;
  whatsapp_fab: boolean;
  newsletter: boolean;
  testimonials: boolean;
  swipe_cards: boolean;
  phone_recommendation: boolean;
  compare: boolean;
  imei_checker: boolean;
  sell_phone: boolean;
  device_score: boolean;
  passport_sharing: boolean;
  giveaways: boolean;
  passport_system: boolean;
  ownership_transfer: boolean;
  service_history: boolean;
  verification_ledger: boolean;
  imei_scan: boolean;
  barcode_scan: boolean;
  duplicate_imei_warning: boolean;
}

const DEFAULTS: FeatureToggles = {
  marketplace: true,
  trade_ins: true,
  repairs: true,
  demo_mode: true,
  whatsapp_fab: true,
  newsletter: true,
  testimonials: true,
  swipe_cards: true,
  phone_recommendation: true,
  compare: true,
  imei_checker: true,
  sell_phone: true,
  device_score: true,
  passport_sharing: true,
  giveaways: true,
  passport_system: true,
  ownership_transfer: true,
  service_history: true,
  verification_ledger: true,
  imei_scan: true,
  barcode_scan: true,
  duplicate_imei_warning: true,
};

const SETTINGS_KEY = "feature_toggles";

export const useFeatureToggles = () => {
  const [toggles, setToggles] = useState<FeatureToggles>(DEFAULTS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      const { data } = await supabase
        .from("store_settings")
        .select("value")
        .eq("key", SETTINGS_KEY)
        .maybeSingle();
      if (data?.value && typeof data.value === "object") {
        setToggles({ ...DEFAULTS, ...(data.value as Partial<FeatureToggles>) });
      }
      setLoading(false);
    };
    fetch();
  }, []);

  return { toggles, loading };
};

export const useFeatureEnabled = (feature: keyof FeatureToggles) => {
  const { toggles, loading } = useFeatureToggles();
  return { enabled: toggles[feature], loading };
};
